<app-svg-icon style="cursor: pointer;" name="editblue"></app-svg-icon>